// extracted by mini-css-extract-plugin
module.exports = {"colMin":"styles_colMin__2j6pI","colCheckbox":"styles_colCheckbox__3az6s"};